import {info} from "services-comun/modules/browser/log";

import { Auth } from "../../../services/auth";
import { IConfig } from "../../../config";
import { Ruta, IRuta } from "../../ruta";

export class AdminPerfil extends Ruta {
    /* STATIC */
    public static build(config: IConfig, id: number): AdminPerfil {
        return new this({
            id,
            ruta: `${config.router.basePath}/admin/perfil/`,
        });
    }

    /* INSTANCE */
    public constructor(data: IRuta) {
        super(data);
    }

    public async check(path: string): Promise<void> {
        if (!path.startsWith(this.data.ruta)) {
            return Promise.reject("Admin/Perfil: Rechazada");
        }
    }

    public async load(auth: Auth, config: IConfig, state?: any): Promise<void> {
        info("Cargando NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        await NavBar.load(auth, config, state);
        info("Cargando Admin/Perfil");
        const {AdminPerfil} = await import(/* webpackChunkName: "admin-perfil" */ `../../../componentes/admin/perfil`);
        await AdminPerfil.load(auth, config, state);
    }

    public async unload(): Promise<void> {
        // info("Descargando NavBar");
        // const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        // await NavBar.unload();
        info("Descargando Admin/Perfil");
        const {AdminPerfil} = await import(/* webpackChunkName: "admin-perfil" */ `../../../componentes/admin/perfil`);
        await AdminPerfil.unload();
    }

    public async updateEstado(state?: any): Promise<void> {
        info("Actualizando el estado de NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../componentes/navbar`);
        await NavBar.updateEstado(state);
        info("Actualizando el estado de Admin/Perfil");
        const {AdminPerfil} = await import(/* webpackChunkName: "admin-perfil" */ `../../../componentes/admin/perfil`);
        await AdminPerfil.updateEstado(state);
    }
}
